var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.addpart)?_c('div',{staticClass:"w-5 h-5 rounded-full bg-primary mr-4 relative"},[_c('div',{staticClass:"w-2 h-2 rounded-full absolute bg-white radiobox"})]):_vm._e(),(!_vm.addpart)?_c('div',{staticClass:"w-5 h-5 rounded-full border border-primary mr-4"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }